var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivitiesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#C6DDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 28.3L22.675 25.65C22.6083 25.5167 22.5125 25.4167 22.3875 25.35C22.2625 25.2833 22.1333 25.25 22 25.25H16V19.5C16 19.1 16.15 18.75 16.45 18.45C16.75 18.15 17.1 18 17.5 18H34.5C34.9 18 35.25 18.15 35.55 18.45C35.85 18.75 36 19.1 36 19.5V25.25H30.475L28.675 21.675C28.6083 21.5417 28.5125 21.4458 28.3875 21.3875C28.2625 21.3292 28.1333 21.3 28 21.3C27.8667 21.3 27.7375 21.3292 27.6125 21.3875C27.4875 21.4458 27.3917 21.5417 27.325 21.675L24 28.3ZM17.5 34C17.1 34 16.75 33.85 16.45 33.55C16.15 33.25 16 32.9 16 32.5V26.75H21.525L23.325 30.35C23.3917 30.4833 23.4875 30.5833 23.6125 30.65C23.7375 30.7167 23.8667 30.75 24 30.75C24.1333 30.75 24.2625 30.7167 24.3875 30.65C24.5125 30.5833 24.6083 30.4833 24.675 30.35L28 23.7L29.325 26.35C29.3917 26.4833 29.4875 26.5833 29.6125 26.65C29.7375 26.7167 29.8667 26.75 30 26.75H36V32.5C36 32.9 35.85 33.25 35.55 33.55C35.25 33.85 34.9 34 34.5 34H17.5Z",
    fill: "#1A2CCE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesIcon);
export default __webpack_public_path__ + "static/media/activities_icon.ddfe836ce8049cbd86d2b44a41c0d713.svg";
export { ForwardRef as ReactComponent };